import * as React from "react";
import { Field } from "@progress/kendo-react-form";
import { StackLayout } from "@progress/kendo-react-layout";

import { FormDatePicker, FormInput, FormDropDownList } from "../FormComponents";
import { requiredValidator } from "../validators";

const prefaceRelease = "<h2 style=\"text-align: center;\"><strong>Participant (Client, Pet Owner or Guardian) Release Agreement<\/strong><\/h2>\r\n<p>Community Veterinary Outreach (&ldquo;CVO&rdquo;) is a volunteer-based registered charity that provides veterinary care and treatment to animals to improve the health of the animal and support the well-being of their owners or guardians. CVO accepts participants (client, pet owner, or guardian) on a referral basis from community partnerships that include area shelters, municipal public health, community health centres and mental health organizations. The care and treatment provided by CVO involves risk and CVO cannot assume responsibility for you or your pets&rsquo; exposure to these risks. Therefore, in order to participate with CVO and allow your pets to receive care and treatment, please review and sign this Agreement. If you have not yet reached the age of 18, a parent or legal guardian must sign this Agreement for you. If you have any questions please contact the primary referral agency for this clinic. A copy of this Agreement will be provided to you upon request.<\/p>\r\n<p style=\"text-align: center;\"><strong>ALL<\/strong> sections of this form <strong>MUST<\/strong> be completed to be accepted. <br \/><\/p>\r\n<p>I am 18 years of age or older and am bringing my pet voluntarily to CVO to be treated and to receive veterinary care. I agree to allow CVO to treat my pet on my own free will.<\/p>\r\n<p>I understand that my pet and I may be exposed to other animals and pet owners while being treated by CVO. Other animals may carry certain diseases which can spread to me and\/or my pet. Also, these other animals can bite, scratch, or otherwise injure my pet or me, and these other animals do not belong to CVO. By allowing CVO to treat my pet, I will not hold CVO, or any social agency working with CVO (including the primary referral agency indicated above), liable or responsible for any loss, damage, illness or injury, including death, suffered by my pet or me at a CVO clinic or treatment event.<\/p>\r\n<p>I have read and I understand this Agreement and the referring working (witnessed herein) acting on behalf of the CVO has explained this Agreement to me before signing freely and voluntarily.<\/p>\r\n<p><strong>Please date and sign in front of a witness who is at least 18 years old:<\/strong><\/p>\r\n\r\n<hr \/>";
const prefacePIP = "<h2 style=\"text-align: center;\"><strong>Personal Information Policy<\/strong><\/h2>\r\n" +
    "I understand that Community Veterinary Outreach has a Personal Information policy in accordance with the requirements of the Personal Information Protection and Electronic Documents Act.<br/><br/>By signing below, I am consenting to the collection, use and disclosure of my personal information(such as name, phone number, address, and pet's medical records) in accordance with the purposes set out in the Policy which includes the following:<br/><br/>" +
    "1. Maintaining complete and accurate client files, and complying with provincial acts and regulations;<br/>" +
    "2. Providing goods and services to veterinary clients, including contacting clients to schedule appointments and follow up on patient treatment<br/>" +
    "3. Communicating and working with third parties providing veterinary medical or other services to clients, including other veterinary facilities, laboratories, and insurance companies for which you have an existing policy<br/>" +
    "4. Sharing your pet's medical records, including rabies vaccination status, to support the public health department's efforts to track the risk of rabies transmission in your municipality; and<br/>" +
    "5. Use of non- identified information collected from the referral form for research purposes in order to fulfill Community Veterinary Outreach's mandate of 'contributing to the scientific knowledge base on social issues involving animals.'<br/><br/>" +
    "I understand that:<br/>" +
    "1. My personal information will not be used or disclosed for purposes other than those for which it was collected.Except with my consent, or except where use or disclosure is required by law;<br/>" +
    "2. I have the right to view my personal information and have it amended, if inaccurate or incomplete; and<br/>" +
    "3. A copy of the Policy will be provided on request.<br/><br/>" +
    "I consent to photographs being taken of myself and my pet, and waive ownership of any photographic records taken by Community Veterinary Outreach and agree to permit Community Veterinary Outreach to use my image, or my pet's image, (in photograph, digital, or electronic form) for and in Community Veterinary Outreach publications, posters, web-site or other medial, without limitation, and agree not to make any claim for misappropriation of personality, breach of privacy, or other loss or damages against Community Veterinary Outreach in respect thereof. Any photos taken will not be distributed for use by a third party.";

export interface ExamNewWaiversProps {
    clientName: string,
    petName: string,
}

const ExamNewWaivers = ({
    clientName,
    petName
}: ExamNewWaiversProps) => {
    return (
        <div className={"sds-questionnaire"}>
            <span dangerouslySetInnerHTML={{ __html: prefaceRelease }} />
            <fieldset
                style={{}}
                className={"k-form-fieldset"}
            >
                <StackLayout gap={48}>
                    <Field
                        label={"Date*"}
                        name={"A149"}
                        component={FormDatePicker}
                        validator={requiredValidator}
                        placeholder=""
                   />
                    <Field
                        label={"Notes"}
                        name={"N149"}
                        component={FormInput}
                    />
                    <div />
                </StackLayout>
                <StackLayout gap={48}>
                    <Field
                        label={"Initials of Client*"}
                        name={"A150"}
                        component={FormInput}
                        validator={requiredValidator}
                    />
                    <Field
                        label={"Client"}
                        name={"X1"}
                        component={FormInput}
                        defaultValue={clientName}
                        disabled={true}
                    />
                    <Field
                        label={"Pet"}
                        name={"X2"}
                        component={FormInput}
                        defaultValue={petName}
                        disabled={true}
                    />
                </StackLayout>
                <StackLayout gap={48}>
                    <Field
                        label={"Initials of Witness*"}
                        name={"A151"}
                        component={FormInput}
                        validator={requiredValidator}
                    />
                    <div /><div />
                </StackLayout>
            </fieldset>

            <span dangerouslySetInnerHTML={{ __html: prefacePIP }} />
            <fieldset
                style={{}}
                className={"k-form-fieldset"}
            >
                <StackLayout gap={48}>
                    <Field
                        label={"I agree to the Personal Information Policy*"}
                        name={"A164"}
                        component={FormDropDownList}
                        data={["Yes", "No"]}
                        validator={requiredValidator}
                   />
                    <Field
                        label={"Notes"}
                        name={"N164"}
                        component={FormInput}
                    />
                    <div />
                </StackLayout>
                <StackLayout gap={48}>
                    <Field
                        label={"Initials*"}
                        name={"A165"}
                        component={FormInput}
                        validator={requiredValidator}
                    />
                    <Field
                        label={"Client"}
                        name={"X3"}
                        component={FormInput}
                        defaultValue={clientName}
                        disabled={true}
                    />
                    <Field
                        label={"Pet"}
                        name={"X4"}
                        component={FormInput}
                        defaultValue={petName}
                       disabled={true}
                    />
                </StackLayout>
                <StackLayout gap={48}>
                    <Field
                        label={"Witness Initials*"}
                        name={"A166"}
                        component={FormInput}
                        validator={requiredValidator}
                    />
                    <div /><div />
                </StackLayout>
            </fieldset>
        </div>
    )
}
export default ExamNewWaivers;